var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-menu",class:[
    {
      'is-open': _vm.$store.getters.getMenuOpen,
      'is-scroll':
        _vm.$store.getters.getPageScrollY > _vm.$store.getters.getPageHeight * 0.75,
    } ]},[_c('div',{staticClass:"tm__inner"},[_c('ul',{staticClass:"tm__list"},_vm._l((_vm.list),function(item,index){return _c('li',{key:("menu" + index),ref:"items",refInFor:true,staticClass:"tm__item"},[_c('n-link',{staticClass:"tm__target",attrs:{"to":item.link},domProps:{"innerHTML":_vm._s(item.name)}})],1)}),0)]),_vm._v(" "),_c('mq-layout',{staticClass:"tm__bg",attrs:{"mq":"desktop"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }